export default __webpack_public_path__ + "static/media/Concurso Internacional de Bandas MMM_Lineamientos 2025.8f0dfadc.pdf";